import {Box} from '@mui/material';
import Barcode from 'react-barcode';

const FieldBarcode=({value,displayValue,height,width})=>{
    return (
        <Box sx={{flex:1,minWidth:0}}>
            {value&&<Barcode value={value} height={height} width={width} displayValue={displayValue}/>}
        </Box>
    );
}

export default FieldBarcode;
